exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-error[data-v-13337b22] {\n    color: #ff5252 !important;\n    border-color: #ff5252 !important;\n}\n\n", ""]);

// exports
